/* JHN Suite — entrée front-end. */
import './styles/theme.css';
import './styles/glass.css';
import 'quill/dist/quill.snow.css';
import 'quill-cursors/css';
import './styles/apps.css';
import './styles/docs-editor.css';
import './styles/messages.css';

import { api } from './api.js';
import { route, start, navigate } from './router.js';
import { el, clear } from './ui/dom.js';
import { Shell } from './ui/shell.js';
import { renderLogin } from './apps/login.js';
import { renderHome } from './apps/home.js';
import { renderDrive } from './apps/drive.js';
import { renderDocs } from './apps/docs.js';
import { renderSheets } from './apps/sheets.js';
import { renderSlides } from './apps/slides.js';
import { renderCalendar } from './apps/calendar.js';
import { renderTasks } from './apps/tasks.js';
import { renderMessages } from './apps/messages.js';
import { renderMeet } from './apps/meet.js';
import { renderAdmin } from './apps/admin.js';

const EDITORS = { doc: renderDocs, sheet: renderSheets, slides: renderSlides };

// Un éditeur de fichier (doc/sheet/slides) s'ouvre en plein écran, dans son
// propre onglet, sans la coquille JHN — exactement comme Google Docs.
function editorMatch(pathname) {
  const m = pathname.match(/^\/(doc|sheet|slides)\/(.+)$/);
  return m ? { type: m[1], id: decodeURIComponent(m[2]) } : null;
}

function renderStandaloneEditor(ed, user) {
  const app = document.getElementById('app');
  app.removeAttribute('aria-busy');
  clear(app);
  const container = el('div', { class: 'standalone' });
  app.appendChild(container);
  const ctx = {
    content: container,
    params: { id: ed.id },
    user,
    standalone: true,
    navigate: (p) => { window.location.href = p; },
    setCrumbs: () => {},
    setSearch: () => {},
    shell: { currentFolder: null, create: () => {} },
  };
  EDITORS[ed.type](ctx);
}

async function boot() {
  let cfg = { allowDevLogin: false };
  try { cfg = await api.get('/api/config'); } catch {}

  let me = null;
  try { me = (await api.get('/auth/me')).user; } catch {}
  if (!me) { renderLogin(cfg); return; }

  // Lien profond / nouvel onglet vers un éditeur -> plein écran autonome.
  const ed = editorMatch(location.pathname);
  if (ed) { renderStandaloneEditor(ed, me); return; }

  const shell = new Shell(me);
  const simple = (view, navKey) => (params) => shell.render(view, params, navKey);
  const drive = (mode, navKey) => (params) =>
    shell.render((ctx) => renderDrive(ctx, mode, params.id || null), params, navKey);

  route('/', simple(renderHome, 'home'));
  route('/drive', drive('folder', 'drive'));
  route('/drive/:id', drive('folder', 'drive'));
  route('/recent', drive('recent', 'recent'));
  route('/starred', drive('starred', 'starred'));
  route('/shared', drive('shared', 'shared'));
  route('/trash', drive('trash', 'trash'));
  route('/calendar', simple(renderCalendar, 'calendar'));
  route('/tasks', simple(renderTasks, 'tasks'));
  route('/messages', simple(renderMessages, 'messages'));
  route('/meet', simple(renderMeet, 'meet'));
  route('/meet/:room', simple(renderMeet, 'meet'));
  route('/admin', simple(renderAdmin, 'admin'));

  start(() => navigate('/', { replace: true }));
}

boot();
